import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { ScrollDetector } from 'legacyComponents/scrollDetector';
import PropTypes from 'prop-types';

@observer
export class HoverElement extends React.Component {
  UNSAFE_componentWillMount() {
    const { element } = this.props;
    if (!element) return;
    const { left, top } = element.getBoundingClientRect();
    [this.posX, this.posY] = [left, top];
  }

  UNSAFE_componentWillReceiveProps() {
    const { element } = this.props;
    if (!element) return;
    const { left, top } = element.getBoundingClientRect();
    [this.posX, this.posY] = [left, top];
  }

  onOuterClick = e => {
    if (e.target.dataset.modal) {
      this.props.onHideInput();
    }
    return null;
  };

  render() {
    const { offSetX, offSetY, hideOnScroll = true, children } = this.props;
    return (
      <ScrollDetector
        onOuterClick={this.onOuterClick}
        onWindowScroll={() => hideOnScroll && this.onOuterClick()}
        data-modal={true}
      >
        <Wrapper
          left={`${this.posX + offSetX}px`}
          top={`${this.posY + offSetY}px`}
        >
          {children}
        </Wrapper>
      </ScrollDetector>
    );
  }
}

const Wrapper = styled.div`
  position: absolute;
  left: ${props => props.left};
  top: ${props => props.top};
`;

HoverElement.propTypes = {
  offSetX: PropTypes.number,
  offSetY: PropTypes.number,
  children: PropTypes.node,
  onHideInput: PropTypes.func,
  element: PropTypes.object,
  hideOnScroll: PropTypes.bool,
};
